module.exports = __webpack_public_path__ + "img/footer_logo.ce711de8.svg";